export const SchedulerConstants = {
    GET_SCHEDULER_REQUEST: 'SCHEDULER/GET_SCHEDULER_REQUEST',
    GET_SCHEDULER_SUCCESS: 'SCHEDULER/GET_SCHEDULER_SUCCESS',
    GET_SCHEDULER_FAILED: 'SCHEDULER/GET_SCHEDULER_FAILED',
    UPDATE_APPLIED_FILTERS: 'SCHEDULER/UPDATE_APPLIED_FILTERS',
    GET_SCHEDULER_EMPTY_CHECK_REQUEST: 'SCHEDULER/GET_SCHEDULER_EMPTY_CHECK_REQUEST',
    GET_SCHEDULER_EMPTY_CHECK_SUCCESS: 'SCHEDULER/GET_SCHEDULER_EMPTY_CHECK_SUCCESS',
    GET_SCHEDULER_EMPTY_CHECK_FAILED: 'SCHEDULER/GET_SCHEDULER_EMPTY_CHECK_FAILED',
  };